export * from 'vega-util'

export const startsWith = (subject: string, prefix: string) => {
  return subject.indexOf(prefix) === 0;
};



// WEBPACK FOOTER //
// ./src/util.ts